import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MenuLayout from "./MenuLayout";
import "../styles/NotificationsPage.css";
import { getNotifications, markNotificationRead } from "../api/notifications";

const NotificationsPage = () => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError("");
      try {
        const data = await getNotifications();
        setNotifications(Array.isArray(data?.results) ? data.results : []);
      } catch (err) {
        setError(err?.message || "خطا در دریافت اعلان‌ها");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleRead = async (item) => {
    if (item.is_read) return;
    try {
      await markNotificationRead(item.id);
      setNotifications((current) =>
        current.map((notification) =>
          notification.id === item.id ? { ...notification, is_read: true } : notification
        )
      );
      window.dispatchEvent(new Event("touch-notifications-updated"));
    } catch (err) {
      setError(err?.message || "ثبت وضعیت اعلان انجام نشد");
    }
  };

  const handleAction = async (event, item) => {
    event.stopPropagation();
    await handleRead(item);
    if (item.action_url) {
      navigate(item.action_url);
    }
  };

  return (
    <MenuLayout>
      <section className="notif-page">
        <header className="notif-header">
          <h1 className="notif-title">پیام‌ها</h1>
          <p className="notif-subtitle">اعلان‌های عمومی و پیام‌های اختصاصی حساب شما در این بخش نمایش داده می‌شوند.</p>
        </header>

        {error && <div className="notif-empty">{error}</div>}
        <div className="notif-list">
          {loading ? (
            <div className="notif-empty">در حال دریافت اعلان‌ها...</div>
          ) : notifications.length === 0 ? (
            <div className="notif-empty">اعلانی برای شما ثبت نشده است.</div>
          ) : (
            notifications.map((item) => (
              <div
                role="button"
                tabIndex={0}
                className={`notif-item ${item.is_read ? "notif-read" : ""}`}
                key={item.id}
                onClick={() => handleRead(item)}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    handleRead(item);
                  }
                }}
              >
                <div className="notif-status">
                  {item.is_read ? (
                    <>
                      <span className="notif-status-text">خوانده شده</span>
                      <span className="notif-status-check">✓</span>
                    </>
                  ) : (
                    <span className="notif-status-text">خوانده نشده</span>
                  )}
                </div>
                <div className="notif-text">
                  {item.title && <strong className="notif-item-title">{item.title}</strong>}
                  <span>{item.message || ""}</span>
                  {item.action_url && item.action_label && (
                    <button
                      type="button"
                      className="notif-action"
                      onClick={(event) => handleAction(event, item)}
                    >
                      {item.action_label}
                    </button>
                  )}
                </div>
                <div className="notif-icon">
                  <img src="/images/icons/top-bell.svg" alt="" />
                </div>
              </div>
            ))
          )}
        </div>
      </section>
    </MenuLayout>
  );
};

export default NotificationsPage;
